import {KpiInfo, ValidationError, Validator} from "../../../../../types/types";
import {StringUtils} from "../../../../../utils/stringUtils";

export class KpiDefinitionValidator implements Validator<KpiInfo> {
    validate(info: KpiInfo): ValidationError[] {
        const errors: ValidationError[] = [];
        const name = info.name;
        if (StringUtils.isEmpty(name) || name.length < 5) {
            errors.push(new ValidationError("name", "Please provide a meaningful KPI name"))
        }
        if (StringUtils.isEmpty(info.description) || info.description.length < 20) {
            errors.push(new ValidationError("description", "Oops too short description! Please elaborate about your KPI"))
        }
        if (StringUtils.isEmpty(info.owner)) {
            errors.push(new ValidationError("owner", "Please provide your name"))
        }
        if (info.extendedAttributes && !StringUtils.isEmpty(info.extendedAttributes.documentation)) {
            try {
                new URL(info.extendedAttributes.documentation);
            } catch (_) {  
                errors.push(new ValidationError("documentation", "Please provide a valid url"))
            }
        }
        return errors;
    }
}